module.exports = __webpack_public_path__ + "02a4472da63dd57d6fc16b929b95017f.jpg";